<div class="container col-10">

  <div>
      <div class="modal-header">
          <h5 class="modal-title text-start">Para continuar, favor validar o captcha:</h5>
      </div>
  </div>
 <br>
  <div class="text-align-center" *ngIf="chavePublicaCaptcha">
    <div id="review_recaptcha" class="display-inline-block">
        <form [formGroup]="captchaFormGroup">
          <ngx-recaptcha2 #captchaElem
            [siteKey]="chavePublicaCaptcha"
            (reset)="handleReset()"
            (expire)="handleExpire()"
            (load)="handleLoad()"
            (success)="handleSuccess($event)"
            [useGlobalDomain]="false"
            [size]="size"
            [hl]="lang"
            [theme]="theme"
            [type]="type"
            formControlName="recaptcha">
          </ngx-recaptcha2>
        </form>
    </div>    
  </div>
</div>

